import PropTypes from "prop-types";

const Dropdown = ({
    label,
    options,
    value,
    onChange,
    name,
    placeholder,
    disabled,
    optionLabelKey,
    optionValueKey,
}) => {
    const handleChange = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
    };

    const renderOptions = () => {
        if (!Array.isArray(options) || options.length === 0) {
            return null;
        }

        return options.map((option) => {
            const optionValue = typeof option === "object"
                ? option[optionValueKey] ?? option.value
                : option;
            const optionLabel = typeof option === "object"
                ? option[optionLabelKey] ?? option.label
                : option;

            return (
                <option key={optionValue} value={optionValue}>
                    {optionLabel}
                </option>
            );
        });
    };

    return (
        <div className="dropdown-wrapper">
            {label && <label className="dropdown-label">{label}</label>}
            <select
                className={`custom-dropdown ${!value ? 'empty' : ''}`}
                name={name}
                value={value}
                onChange={handleChange}
                disabled={disabled}
            >
                <option value="" disabled hidden>
                    Select...
                </option>
                {renderOptions()}
            </select>
        </div>
    );
};

Dropdown.propTypes = {
    label: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    optionLabelKey: PropTypes.string,
    optionValueKey: PropTypes.string,
};

Dropdown.defaultProps = {
    options: [],
    value: "",
    onChange: null,
    placeholder: "",
    disabled: false,
    optionLabelKey: "label",
    optionValueKey: "value",
};

export default Dropdown;
